/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const PlayCircleIcon = createIcon({
    displayName: 'PlayCircleIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M12.775 10.019a35.382 35.382 0 0 1 2.596 1.721.326.326 0 0 1 0 .52c-.48.35-.99.7-1.525 1.049a38.724 38.724 0 0 1-2.163 1.308 34.52 34.52 0 0 1-1.612.851c-.198.098-.43-.042-.448-.271a39.052 39.052 0 0 1-.103-1.888 42.735 42.735 0 0 1 0-2.618c.02-.652.055-1.284.103-1.888.018-.229.25-.37.448-.271a35.03 35.03 0 0 1 1.612.85c.36.203.725.415 1.092.637Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M4 12c0-5.138 2.862-8 8-8 5.137 0 8 2.862 8 8 0 5.137-2.863 8-8 8-5.138 0-8-2.863-8-8Zm1.333 0c0 4.424 2.243 6.667 6.667 6.667 4.424 0 6.667-2.243 6.667-6.667 0-4.424-2.243-6.667-6.667-6.667-4.424 0-6.667 2.243-6.667 6.667Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M12.866 9.453a48.442 48.442 0 0 1 3.461 2.212.41.41 0 0 1 0 .67c-.64.449-1.32.9-2.032 1.348a51.7 51.7 0 0 1-2.884 1.682c-.732.396-1.451.762-2.15 1.094a.42.42 0 0 1-.597-.349 48.412 48.412 0 0 1-.137-2.427 52.96 52.96 0 0 1 0-3.366c.026-.838.073-1.65.137-2.427a.42.42 0 0 1 .598-.35 48.175 48.175 0 0 1 3.604 1.913Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M1 12C1 4.936 4.936 1 12 1s11 3.936 11 11-3.936 11-11 11S1 19.064 1 12Zm2 0c0 5.972 3.028 9 9 9 5.972 0 9-3.028 9-9 0-5.972-3.028-9-9-9-5.972 0-9 3.028-9 9Z",
            clipRule: "evenodd"
        })
    ]
});
PlayCircleIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'PlayCircleIcon'
};
export { PlayCircleIcon };

//# sourceMappingURL=play-circle.js.map